"use strict";
/**
 * Card Service file
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.CardService = void 0;
var cardinal_sandbox_js_1 = require("@kushki/cardinal-sandbox-js");
var Identifiers_1 = require("./../../lib/constant/Identifiers");
var dot = require("dot-object");
var KushkiError_1 = require("./../../lib/generic/KushkiError");
var ErrorEnum_1 = require("./../../lib/infrastructure/ErrorEnum");
var inversify_1 = require("inversify");
require("reflect-metadata");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var UtilsService_1 = require("./../../lib/service/UtilsService");
var Kushki_1 = require("./../../lib/Kushki");
var CardService = /** @class */ (function () {
    function CardService(gateway, authService, antiFraud) {
        this._3Dsecure = "active_3dsecure";
        this._sandboxEnable = false;
        this._gateway = gateway;
        this._antiFraud = antiFraud;
        this._authService = authService;
        this._receipt = {
            amount: "totalAmount",
            "card.cvc": "card.cvv",
            "card.expiryMonth": "card.expiryMonth",
            "card.expiryYear": "card.expiryYear",
            "card.name": "card.name",
            "card.number": "card.number",
            currency: "currency",
            isDeferred: "isDeferred",
            jwt: "jwt",
            months: "months",
            savePaymentData: "savePaymentData",
            sessionId: "sessionId",
            userId: "userId",
            walletId: "walletId"
        };
    }
    CardService_1 = CardService;
    CardService.prototype.requestToken = function (request, mid, isTest, regional) {
        var _this = this;
        return this._gateway.requestMerchantSettings(mid, isTest, regional).pipe(operators_1.switchMap(function (merchant) {
            _this._setSandboxEnable(!!merchant.sandboxEnable);
            return rxjs_1.forkJoin([
                _this._getScienceSession(request, mid, isTest, merchant),
                _this._getCybersourceJwt(merchant, mid, isTest, regional, Object.prototype.hasOwnProperty.call(request, "card")
                    ? request.card.number
                    : undefined),
            ]);
        }), operators_1.mergeMap(function (_a) {
            var sift_object = _a[0], jwt = _a[1];
            request.isDeferred =
                request.isDeferred === undefined ? false : request.isDeferred;
            if (Boolean(request.cvv))
                request.card = { cvc: request.cvv };
            _this._checkRequestBody(request);
            var data_to_transform = __assign(__assign({}, request), sift_object);
            if (jwt !== undefined)
                data_to_transform.jwt = jwt;
            return rxjs_1.forkJoin([
                rxjs_1.of(dot.transform(_this._receipt, data_to_transform)),
                request.walletId
                    ? _this._authService.getAuthorizationToken()
                    : rxjs_1.of(undefined),
            ]);
        }), operators_1.concatMap(function (_a) {
            var final_request = _a[0], jwt = _a[1];
            return _this._gateway.requestToken(final_request, mid, isTest, regional, jwt);
        }));
    };
    CardService.prototype.requestTokenCharge = function (request, mid, isTest, regional) {
        var _this = this;
        return this._gateway.requestMerchantSettings(mid, isTest, regional).pipe(operators_1.switchMap(function (merchant) {
            return rxjs_1.iif(function () {
                return request.sessionId !== undefined &&
                    request.sessionId !== null &&
                    (request.userId !== undefined && request.userId !== null);
            }, _this._getRequestSiftObject(request.userId, request.sessionId), _this._antiFraud.createSiftScienceSession(request.subscriptionId, "", mid, isTest, merchant));
        }), operators_1.switchMap(function (siftObject) {
            if (siftObject.userId === null)
                delete siftObject.userId;
            if (siftObject.sessionId === null)
                delete siftObject.sessionId;
            return _this._gateway.requestTokenCharge(__assign({ subscriptionId: request.subscriptionId }, siftObject), mid, isTest, regional);
        }));
    };
    CardService.prototype.requestSubscriptionToken = function (subscriptionTokenRequest, mid, isTest, regional) {
        var _this = this;
        return this._gateway.requestMerchantSettings(mid, isTest, regional).pipe(operators_1.switchMap(function (merchant) {
            return _this._getScienceSession(subscriptionTokenRequest, mid, isTest, merchant);
        }), operators_1.concatMap(function (siftObject) {
            _this._checkRequestBody(subscriptionTokenRequest);
            var data_to_transform = __assign({}, subscriptionTokenRequest);
            if (siftObject.userId === null || siftObject.sessionId === null)
                data_to_transform.siftObject = __assign({}, siftObject);
            return rxjs_1.forkJoin([
                rxjs_1.of(dot.transform(_this._receipt, data_to_transform)),
                subscriptionTokenRequest.walletId
                    ? _this._authService.getAuthorizationToken()
                    : rxjs_1.of(undefined),
            ]);
        }), operators_1.switchMap(function (_a) {
            var body = _a[0], jwt = _a[1];
            return _this._gateway.requestSubscriptionToken(body, mid, isTest, regional, jwt);
        }));
    };
    CardService.prototype.requestDeferred = function (binBody, mid, isTest, regional) {
        return this._gateway.requestDeferredConditions(mid, binBody.bin, isTest, regional);
    };
    CardService.prototype.requestBinInfo = function (binBody, mid, isTest, regional) {
        return this._gateway.requestBinInfo(mid, String(binBody.bin).substring(0, 6), isTest, regional);
    };
    CardService.prototype.validate3DS = function (body, mid, isTest, regional, callback) {
        var _this = this;
        if (!UtilsService_1.UtilsService.sGet(body, "security.authRequired", false)) {
            callback({ isValid: true });
            return;
        }
        if (this._sandboxEnable)
            return CardService_1._ccaSandbox(body, callback);
        if (isTest) {
            // tslint:disable-next-line:no-duplicate-string
            Promise.resolve().then(function () { return require("cardinal-commerce-songbird-staging"); }).then(function () {
                CardService_1._ccaCardinal(body);
            });
            Promise.resolve().then(function () { return require("cardinal-commerce-songbird-staging"); }).then(function () {
                _this._completeCardinal(body.secureId, mid, isTest, regional, callback);
            });
        }
        else {
            // tslint:disable-next-line:no-duplicate-string
            Promise.resolve().then(function () { return require("cardinal-commerce-songbird"); }).then(function () {
                CardService_1._ccaCardinal(body);
            });
            Promise.resolve().then(function () { return require("cardinal-commerce-songbird"); }).then(function () {
                _this._completeCardinal(body.secureId, mid, isTest, regional, callback);
            });
        }
    };
    CardService.prototype._checkCardLength = function (request) {
        if (request.card.number.length < 14 || request.card.number.length > 19)
            throw new KushkiError_1.KushkiError(ErrorEnum_1.ERRORS.E005);
    };
    CardService.prototype._getScienceSession = function (request, mid, isTest, merchant) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.switchMap(function () {
            if (request.card && request.card.number !== undefined)
                return _this._antiFraud.createSiftScienceSession(request.card.number.substring(0, 6), request.card.number.slice(-4), mid, isTest, merchant);
            return rxjs_1.of({
                sessionId: null,
                userId: null
            });
        }));
    };
    CardService.prototype._checkCurrency = function (request) {
        request.currency =
            request.currency === undefined ? "USD" : request.currency;
    };
    CardService.prototype._getRequestSiftObject = function (userId, sessionId) {
        return rxjs_1.of(1).pipe(operators_1.map(function () { return ({
            sessionId: sessionId,
            userId: userId
        }); }));
    };
    CardService.prototype._checkAmount = function (request) {
        if (request.amount !== undefined && typeof request.amount === "string")
            request.amount = parseFloat(request.amount);
    };
    CardService.prototype._checkRequestBody = function (request) {
        this._checkCurrency(request);
        if (Boolean(request.card) && Boolean(request.card.number))
            this._checkCardLength(request);
        this._checkAmount(request);
    };
    CardService.prototype._getCybersourceJwt = function (merchantSettings, mid, isTest, regional, cardNumber) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.switchMap(function () {
            if (merchantSettings[_this._3Dsecure] === true &&
                cardNumber !== undefined)
                return rxjs_1.iif(function () { return !!merchantSettings.sandboxEnable; }, _this._initCybersourceSandbox(mid, isTest, regional), _this._initCybersource(cardNumber, mid, isTest, regional));
            return rxjs_1.of(undefined);
        }));
    };
    CardService.prototype._initCybersource = function (cardNumber, mid, isTest, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.switchMap(function () { return _this._gateway.cybersourceJwt(mid, isTest, regional); }), operators_1.map(function (jwt) {
            if (isTest)
                Promise.resolve().then(function () { return require("cardinal-commerce-songbird-staging"); }).then(function () {
                    CardService_1._initCardinal(jwt, cardNumber);
                });
            else
                Promise.resolve().then(function () { return require("cardinal-commerce-songbird"); }).then(function () {
                    CardService_1._initCardinal(jwt, cardNumber);
                });
            return jwt;
        }));
    };
    // istanbul ignore next
    CardService.prototype._completeCardinal = function (secureServiceId, mid, isTest, regional, callback) {
        var _this = this;
        return window.Cardinal.on("payments.validated", function () { return __awaiter(_this, void 0, void 0, function () {
            var otp_request, secure;
            return __generator(this, function (_a) {
                otp_request = {
                    secureServiceId: secureServiceId,
                    otpValue: ""
                };
                secure = this._gateway.requestSecureServiceValidation(mid, otp_request, isTest, regional);
                return [2 /*return*/, secure.subscribe({
                        error: function (err) {
                            return Kushki_1.Kushki.callbackError(err, callback);
                        },
                        next: function (response) {
                            callback({
                                isValid: CardService_1._is3dsValid(response)
                            });
                        }
                    })];
            });
        }); });
    };
    CardService._initCardinal = function (jwt, cardNumber) {
        window.Cardinal.setup("init", {
            jwt: jwt,
            order: {
                Consumer: {
                    Account: {
                        AccountNumber: cardNumber
                    }
                }
            }
        });
    };
    CardService._ccaCardinal = function (tokenResponse) {
        window.Cardinal["continue"]("cca", {
            AcsUrl: tokenResponse.security.acsURL,
            Payload: tokenResponse.security.paReq
        }, {
            OrderDetails: {
                TransactionId: tokenResponse.security.authenticationTransactionId
            }
        });
    };
    // istanbul ignore next
    CardService._is3dsValid = function (secureOtpResponse) {
        return ("message" in secureOtpResponse &&
            secureOtpResponse.message === "3DS000" &&
            secureOtpResponse.code === "ok");
    };
    CardService.prototype._setSandboxEnable = function (payload) {
        this._sandboxEnable = payload;
    };
    CardService.prototype._initCybersourceSandbox = function (mid, isTest, regional) {
        var _this = this;
        return rxjs_1.of(1).pipe(operators_1.switchMap(function () { return _this._gateway.cybersourceJwt(mid, isTest, regional); }), operators_1.map(function (jwt) {
            cardinal_sandbox_js_1.KushkiCardinalSandbox.init();
            return jwt;
        }));
    };
    CardService._ccaSandbox = function (body, callback) {
        cardinal_sandbox_js_1.KushkiCardinalSandbox["continue"]("cca", {
            AcsUrl: body.security.acsURL,
            Payload: body.security.paReq
        }, {
            OrderDetails: {
                TransactionId: body.security.authenticationTransactionId
            }
        });
        // istanbul ignore next
        cardinal_sandbox_js_1.KushkiCardinalSandbox.on("payments.validated", function () {
            return callback({ isValid: true });
        });
    };
    var CardService_1;
    CardService = CardService_1 = __decorate([
        inversify_1.injectable(),
        __param(0, inversify_1.inject(Identifiers_1.IDENTIFIERS.KushkiGateway)),
        __param(1, inversify_1.inject(Identifiers_1.IDENTIFIERS.AuthService)),
        __param(2, inversify_1.inject(Identifiers_1.IDENTIFIERS.AntiFraud)),
        __metadata("design:paramtypes", [Object, Object, Object])
    ], CardService);
    return CardService;
}());
exports.CardService = CardService;
